import React, { useState } from "react";
import { Card, CardBody, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BasicDropdowns, Dashboard, Href } from "../../../../Constant";
import { DROPDOWN_LIST, DROPDOWN_DATA } from "../../../../Data/UiKit/Dropdown";
import CommonDropDown from "../Common/CommonDropDown";

const BasicDropdown = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);

  return (
    <Col xl="6">
      <Card className="height-equal">
        <CommonCardHeader title={BasicDropdowns} span={DROPDOWN_DATA} />
        <CardBody className="rtl-dropdown">
          <div className="common-flex">
            <div className="btn-group">
              <Dropdown isOpen={open} toggle={toggle}>
                <DropdownToggle caret color="primary">{Dashboard}</DropdownToggle>
                <DropdownMenu className="dropdown-block">
                  <DropdownItem href={Href}>Project</DropdownItem>
                  <DropdownItem href={Href}>Ecommerce</DropdownItem>
                  <DropdownItem href={Href}>Crypto</DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            {DROPDOWN_LIST.map((data, index) => (
              <CommonDropDown item={data} key={index} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default BasicDropdown;
